import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse, SafetyCounterData } from './safety-counter.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SafetyCounterService {
  private apiUrl = `${environment.apiConfig.uri}/counter`;

  constructor(private http: HttpClient) {}

  getCounter(): Observable<SafetyCounterData> {
    return this.http.get<ApiResponse<SafetyCounterData>>(this.apiUrl).pipe(map((r) => r.data));
  }

  updateCounter(lastIncidentDate: Date): Observable<SafetyCounterData> {
    return this.http
      .put<ApiResponse<SafetyCounterData>>(this.apiUrl, { lastIncidentDate })
      .pipe(map((r) => r.data));
  }
}
